/**
 *
 *
 */
/*                                                          */
export const noop: (...a: any[]) => any = () => undefined;
